module.exports = __webpack_public_path__ + "static/NewJune-light-3ed45332409538dd830ff1df8e60e5f8.woff";